import React from "react"
import { Formik, Form, FormikProps } from "formik"

const SkForm = (props: Props) => {
  const {
    children,
    initialValues,
    onSubmit,
    validation,
    validateOnMount,
    enableReinitialize,
    formClassName,
  } = props
  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={validation}
      validateOnMount={validateOnMount}
      enableReinitialize={enableReinitialize}
    >
      {props => <Form className={formClassName}>{children(props)}</Form>}
    </Formik>
  )
}

interface Props {
  initialValues: object
  children(data: FormikProps<object>): React.ReactNode
  onSubmit: IOnSubmit
  validation?: any | (() => any)
  validateOnMount?: boolean
  enableReinitialize?: boolean
  formClassName?: string
}

interface IOnSubmit {
  (values: object, actions: object): void
}

export { SkForm }
